module.exports = __webpack_public_path__ + "img/Naiv.Super_Bilde-fra-pressevisning-av-Kurt-blir-grusom.fc4bee16.jpg";